<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '@/config/axiosConfig';
import { UserStore } from '@/store/UserStore';
import { useUserInfo } from '@/modules/user/useUserInfo';
import HeaderLogin from '@/components/login/HeaderLogin.vue';
import UserLogin from '@/components/login/UserLogin.vue';
import UserSelector from '@/components/login/UserSelector.vue';

const userStore = UserStore();
const router = useRouter();
const isLogin = ref(false);

const redirectToHome = (token: string) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  router.push({ path: '/' });
};

const selectedRole = (selectedRole: any) => {
  const token = selectedRole.token;
  if (token) {
    // once the choice is done, clear the tokens to mitigate the security risk
    userStore.clearTokens();
    useUserInfo().setUserInfo(token);
    useUserInfo().setToken(token);
    redirectToHome(token);
  }
};

const userLogged = async () => {
  isLogin.value = true;
};
</script>

<template>
  <div class="grid">
    <div class="col-12">
      <HeaderLogin v-once />
      <UserSelector v-if="isLogin" @selectedRole="selectedRole" />
      <UserLogin v-else @userLogged="userLogged" />
    </div>
  </div>
</template>
